import { Moon, Sun } from 'lucide-react'
import type React from 'react'
import { useSettingsStore } from '../../stores/settingsStore'

export const ThemeToggle: React.FC = () => {
    const theme = useSettingsStore(s => s.theme)
    const setTheme = useSettingsStore(s => s.setTheme)

    const toggleTheme = () => {
        setTheme(theme === 'dark' ? 'light' : 'dark')
    }

    return (
        <button
            onClick={toggleTheme}
            className="group relative flex items-center w-12 h-7 rounded-full bg-slate-100 dark:bg-slate-800/80 border border-slate-200/80 dark:border-slate-700/80 transition-colors duration-300 hover:border-slate-300 dark:hover:border-slate-600 outline-none shrink-0"
            title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
            aria-label="Toggle theme"
        >
            {/* Sliding Circle */}
            <div 
                className={`absolute left-[3px] top-[2px] w-[22px] h-[22px] rounded-full shadow-[0_1px_3px_rgba(0,0,0,0.1)] transition-transform duration-300 ease-out ${
                    theme === 'dark' 
                        ? 'translate-x-5 bg-indigo-500 shadow-indigo-900/50' 
                        : 'translate-x-0 bg-white'
                }`}
            />
            
            {/* Icons container */}
            <div className="relative w-full flex justify-between items-center px-[6px] z-10 pointer-events-none">
                <Sun 
                    size={12} 
                    className={`transition-colors duration-300 ${
                        theme === 'dark' ? 'text-slate-500' : 'text-amber-500'
                    }`} 
                    strokeWidth={3}
                />
                <Moon 
                    size={12} 
                    className={`transition-colors duration-300 ${
                        theme === 'dark' ? 'text-white' : 'text-slate-400'
                    }`} 
                    strokeWidth={3}
                />
            </div>
        </button>
    )
}
